import { useNavigate } from 'react-router-dom'

const styles = `
body{
    margin:0;
    font-family:'Open Sans',sans-serif;
    background:#f7f8fc;
}

.destination-hero{
    background:#1a2e6e;
    color:white;
    padding:80px 20px;
}

.destination-container{
    max-width:1100px;
    margin:auto;
}

.destination-hero h1{
    font-size:46px;
    margin-bottom:15px;
    font-family:'Nunito',sans-serif;
}

.destination-hero p{
    font-size:18px;
    max-width:720px;
    opacity:.95;
    line-height:1.8;
}

.destination-content{
    max-width:1000px;
    margin:50px auto;
    background:white;
    border-radius:16px;
    padding:45px;
    box-shadow:0 10px 30px rgba(0,0,0,.08);
}

.destination-content h2{
    color:#1a2e6e;
    margin-top:40px;
    margin-bottom:20px;
    font-size:30px;
}

.destination-content h3{
    color:#1a2e6e;
    margin-bottom:15px;
}

.destination-content p{
    line-height:1.9;
    color:#555;
}

.destination-content li{
    margin-bottom:15px;
    line-height:1.8;
}

.highlight{
    background:#eef8f2;
    border-left:6px solid #39b36a;
    padding:25px;
    border-radius:12px;
    margin-top:35px;
}

.process{
    background:#f5f7fb;
    border:1px solid #d8dfef;
    padding:20px;
    border-radius:12px;
    text-align:center;
    font-weight:700;
    color:#1a2e6e;
    margin:25px 0;
}

.back-btn{
    background:#f5a623;
    color:white;
    border:none;
    padding:12px 24px;
    border-radius:8px;
    cursor:pointer;
    font-weight:700;
    margin-bottom:30px;
}

.back-btn:hover{
    opacity:.9;
}

@media(max-width:768px){

.destination-hero{
    padding:55px 20px;
}

.destination-hero h1{
    font-size:34px;
}

.destination-content{
    margin:20px;
    padding:25px;
}

}
`

export default function JapanDestination() {
  const navigate = useNavigate()

  return (
    <>
      <style>{styles}</style>

      <section className="destination-hero">
        <div className="destination-container">
          <button className="back-btn" onClick={() => navigate('/', { state: { scrollTo: 'study-destinations' } })}>
            ← Back
          </button>

          <h1>🇯🇵 Japan</h1>

          <p>
            Known for bullet trains, robotics, and safety,
            <strong> Japan</strong> has rapidly expanded its English-medium university programs, inviting international students to study, work, and build long-term careers.
          </p>
        </div>
      </section>

      <div className="destination-content">
        <h2>✨ Why Choose Japan?</h2>

        <ul>
          <li>
            <strong>Excellent Career Opportunities:</strong> Japan faces a growing demand for skilled graduates and actively welcomes international professionals across
            engineering, IT, business, and healthcare.
          </li>

          <li>
            <strong>Work While Studying:</strong> International students may work up to 28 hours per week during academic sessions and full-time during official holidays.
          </li>

          <li>
            <strong>Government Scholarships:</strong> Access prestigious MEXT and university scholarships that significantly reduce or fully cover tuition fees.
          </li>

          <li>
            <strong>Safe & High Quality of Life:</strong> Enjoy one of the world's safest countries with efficient public transport, modern cities, and outstanding student support.
          </li>
        </ul>

        <h2>📋 Essential Documents</h2>

        <ul>
          <li>
            <strong>Passport & Passport Photos:</strong> Valid passport and embassy-compliant passport-size photographs.
          </li>

          <li>
            <strong>Academic Certificates & Transcripts:</strong> Verified SSC, HSC, Bachelor's, or other educational records.
          </li>

          <li>
            <strong>Language Proficiency:</strong> JLPT for Japanese-medium programs or IELTS/TOEFL for English-medium courses.
          </li>

          <li>
            <strong>Certificate of Eligibility (COE):</strong> Issued through your Japanese university before visa application.
          </li>

          <li>
            <strong>Financial Documents:</strong> Bank solvency certificate, tax documents, and sponsor affidavit where applicable.
          </li>

          <li>
            <strong>Statement of Purpose (SOP):</strong> A detailed explanation of your academic background, career goals, and reasons for choosing Japan.
          </li>
        </ul>

        <h2>🚀 Application & Visa Process</h2>

        <div className="process">University Application → Certificate of Eligibility (COE) → Embassy Visa Application → Fly to Japan 🇯🇵</div>

        <ol>
          <li>
            <strong>University Admission:</strong> Apply to your preferred university and receive an admission offer.
          </li>

          <li>
            <strong>COE Processing:</strong> The university submits your documents to Japanese Immigration to obtain your Certificate of Eligibility.
          </li>

          <li>
            <strong>Student Visa Application:</strong> Submit your COE, passport, financial documents, and application forms to the Embassy of Japan.
          </li>

          <li>
            <strong>Arrival & Residence Card:</strong> Enter Japan and receive your Residence Card during immigration clearance at the airport.
          </li>
        </ol>

        <div className="highlight">
          <h3>🤝 How StudyBuddy Helps</h3>

          <ul>
            <li>
              <strong>Course & Pathway Selection:</strong> We help determine whether an English-medium or Japanese-language program best matches your academic profile and career
              goals.
            </li>

            <li>
              <strong>Sponsor Documentation:</strong> Guidance for preparing clean, verifiable financial records, tax documents, and sponsorship papers.
            </li>

            <li>
              <strong>COE Coordination:</strong> We work closely with universities to ensure your Certificate of Eligibility is processed smoothly.
            </li>

            <li>
              <strong>SOP & Document Review:</strong> Professional review of your Statement of Purpose and supporting application documents.
            </li>

            <li>
              <strong>Visa Assistance:</strong> Complete support for preparing and submitting your Japan student visa application.
            </li>

            <li>
              <strong>Pre-Departure Guidance:</strong> Advice on accommodation, airport arrival, part-time work regulations, and settling into student life in Japan.
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
